import './bootstrap';
import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
import BackLayout from './Layouts/BackLayout.vue';

// Global Loading Spinner Logic
router.on('start', () => {
    const loader = document.getElementById('inertia-loading-overlay');
    if (loader) loader.style.display = 'flex';
});

router.on('finish', () => {
    const loader = document.getElementById('inertia-loading-overlay');
    if (loader) loader.style.display = 'none';
});


createInertiaApp({
    // title: (title) => title || 'Gotransport', // Removed to avoid duplicate title tags
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true });
        let page = pages[`./Pages/${name}.vue`];

        // Ensure page definition matches Inertia expectations
        page = page.default || page;

        // Auto-apply BackLayout for pages in Pages/Back/
        if (name.startsWith('Back/') && !page.layout) {
            page.layout = BackLayout;
        }
        return page;
    },
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, typeof Ziggy !== 'undefined' ? Ziggy : undefined)
            .mount(el);
    },
});